/* Manchester · 2026-05-15 — Force-load PLP lazy images.

   Bug en Symmetry v8: el browser nativo lazy loading falla en PLP
   con 30-40 cards — solo 3/148 imágenes cargaban en el primer pass,
   el resto quedaban como placeholders grises persistentes. El
   IntersectionObserver alternativo no disparaba isIntersecting incluso
   con rootMargin 2000px (algo en el shadow DOM del <product-block>
   web component lo confunde).

   Fix funcional: en init, hacemos src='' → src=s a TODAS las imgs lazy
   pending. Eso fuerza al browser a re-fetch con prioridad normal,
   bypassing el lazy queue. Para 40 cards × 2 imgs × ~30KB cada una =
   ~2.4MB extra cargado (aceptable trade-off; el placeholder gris es
   peor experiencia que un load adicional).

   En scroll-debounced sweep, repetimos para cubrir paginación AJAX.
*/
(function () {
  'use strict';

  // Manchester · 2026-05-20 — agregado `.slider__item` + `carousel-slider`:
  // las cards de los carruseles de home (featured-collection / collections-slider)
  // viven en .slider__item, NO en .product-block wrapper, así que el sweep no las
  // alcanzaba y quedaban en gris permanente. Ahora también se calientan.
  var SEL = 'product-block img[loading="lazy"], .product-block img[loading="lazy"], .product-card img[loading="lazy"], .grid__item img[loading="lazy"], .slider__item img[loading="lazy"], carousel-slider img[loading="lazy"]';

  function warmUp(img) {
    if (!img || img.dataset.mfgWarmed || img.complete) return;
    img.dataset.mfgWarmed = '1';
    img.loading = 'eager';
    if (!img.fetchPriority || img.fetchPriority === 'auto' || img.fetchPriority === 'low') {
      img.fetchPriority = 'high';
    }
    var s = img.src;
    if (s) {
      img.src = '';
      img.src = s;
    }
  }

  function sweep() {
    document.querySelectorAll(SEL).forEach(function (img) {
      if (!img.dataset.mfgWarmed && !img.complete) warmUp(img);
    });
  }

  function init() {
    sweep();
    // Re-sweep on scroll (covers AJAX-loaded pagination + carousel inner sections)
    var scrollTimer = null;
    window.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(sweep, 150);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-warm on DOM mutations (Quick Buy, infinite scroll, AJAX swaps)
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      var anyImg = false;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1 && (n.tagName === 'IMG' || (n.querySelector && n.querySelector('img')))) {
            anyImg = true;
          }
        });
      });
      if (anyImg) sweep();
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
//cache-bust-2026-05-19-1779223510
